import { useState } from 'react';
import { X } from 'lucide-react';
import { CourseSessionsPanel } from './CourseSessionsPanel';

interface SessionWorkspaceOverlayProps {
  sessionId: string;
  onClose: () => void;
  onNavigateToClient?: (customerId: string) => void;
}

export function SessionWorkspaceOverlay({
  sessionId,
  onClose,
  onNavigateToClient
}: SessionWorkspaceOverlayProps) {
  const [panelKey, setPanelKey] = useState(0);

  return (
    <div className="fixed inset-0 z-[80] flex flex-col bg-slate-900/40 backdrop-blur-sm">
      <div className="flex flex-1 min-h-0 flex-col m-2 sm:m-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 shrink-0">
          <p className="text-sm font-semibold text-slate-800 dark:text-slate-100">Session workspace</p>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700"
          >
            <X className="w-3.5 h-3.5" />
            Close
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-3 sm:p-4">
          <CourseSessionsPanel
            key={`overlay-${sessionId}-${panelKey}`}
            mode="manage"
            initialExpandedSessionId={sessionId}
            onNavigateToClient={onNavigateToClient}
            onViewChange={() => setPanelKey((k) => k + 1)}
          />
        </div>
      </div>
    </div>
  );
}
